export const formatChartData = (data, colors = []) => {
  if (!data || data.length === 0) return null;

  const values = data.map((d) => d.value || 0);
  const noData = values.every((v) => v === 0);

  if (noData) return null;

  return {
    labels: data.map((item) => item.type),
    datasets: [
      {
        label: "Values", // FIX: required for bar legend
        data: values,
        backgroundColor: colors,
        borderColor: colors,
        hoverBackgroundColor: colors,
      },
    ],
  };
};
